<div class="customers">
    <div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
        <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
    </div>
    <div class="card">
        <div class="card-header header-background">
            <div class="row">
                <div class="col-sm-9">
                    <p class="welcome-title">Bienvenida, <b *ngIf="megaTutorData !== undefined">{{capitalize(megaTutorData.nombres)}}</b></p>
                </div>
                <div class="col-sm-3">
                    <p class="welcome-subtitle">TUTORES(AS) ASIGNADOS(AS): <b *ngIf="tutorCounter !== 0">{{tutorCounter}}</b></p>
                </div>
            </div>

        </div>
        <div class="card-body">
            <div class="row" style="padding: 20px;">
                <div class="container-flex">
                    <p class="title2">Seguimiento tutores(as)</p>
                    <button class="btn btn-download" style="display: none;">
                        <i class="fa-solid fa-download"></i> DESCARGAR
                    </button>
                </div>
            </div>
            <div class="row" style="padding: 0px 15px 20px 20px;" *ngFor="let tutorData of tutoresData; let indice=index">
                <app-tutor-card [tutorData]="tutorData" [indice]="indice"></app-tutor-card>
            </div>
        </div>
    </div>
</div>